import { render, staticRenderFns } from "./PCB.vue?vue&type=template&id=3149e685&"
import script from "./PCB.vue?vue&type=script&lang=js&"
export * from "./PCB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports